/* Public Klaviyo client integration. No private credentials belong in a theme. */
(function (root, factory) {
  var api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  else root.IRQuizKlaviyo = api;
})(typeof window === 'undefined' ? this : window, function () {
  'use strict';
  var GOALS = {
    pain: 'Reduce Joint Pain & Inflammation',
    wellness: 'Improve General Wellness',
    performance: 'Improve Performance & Recovery',
    skin: 'Improve Skin Health & Anti-Ageing',
    hair: 'Hair Growth'
  };
  var REGIONS = { AU: 'AU', NZ: 'AU', CA: 'CA', US: 'US', GB: 'UK' };
  var INTERNATIONAL_WEARABLES = [
    'infraredi-body-wrap', 'infraredi-body-wrap-plus',
    'infraredi-joint-wrap', 'infraredi-led-light-therapy-mask',
    'infraredi-led-laser-hair-growth-hat'
  ];
  var ANSWERS = {
    goal: Object.keys(GOALS), coverage: ['targeted', 'half', 'full'], form: ['wearable', 'panel'],
    area: ['back', 'joint', 'large'], share: ['me', 'shared', 'premium'],
    setup: ['hang', 'base', 'stand', 'lying'], setupMini: ['tabletop', 'hang']
  };
  function properties(input, config) {
    if (input.consent !== true) throw new Error('Please agree to receive Infraredi emails to request your code.');
    var email = String(input.email || '').trim();
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email) || email.length > 254) throw new Error('Please enter a valid email address.');
    var context = config.context || {}, answers = {}, country = String(context.countryCode || '').toUpperCase();
    Object.keys(ANSWERS).forEach(function (key) {
      var value = (input.answers || {})[key];
      if (ANSWERS[key].indexOf(value) !== -1) answers[key] = value;
    });
    if (!answers.goal) throw new Error('Please complete the quiz before requesting a code.');
    if (!/^[A-Z]{2}$/.test(country)) throw new Error('This offer is not available for the selected country.');
    var region = REGIONS[country] || 'INTL';
    var goal = answers.goal === 'hair' ? (config.hairWelcomeGoal || '') : answers.goal;
    if (!GOALS[goal] || goal === 'hair') throw new Error('The hair-growth welcome offer is not ready yet.');
    var handle = String(input.productHandle || '').trim();
    if (!/^[a-z0-9][a-z0-9-]{0,99}$/.test(handle)) throw new Error('We couldn’t save your product match. Please try again.');
    if (region !== 'AU' && region !== 'CA' && region !== 'US' && INTERNATIONAL_WEARABLES.indexOf(handle) === -1) {
      throw new Error('This product match is not available for your market. Please retake the quiz.');
    }
    var productName = String(input.productName || '').trim().slice(0, 120);
    if (!productName) throw new Error('We couldn’t save your product match. Please try again.');
    var productImage = String(input.productImage || '').trim();
    try {
      var imageUrl = new URL(productImage, context.origin || 'https://www.infraredi.com');
      if (imageUrl.protocol !== 'https:' || !/(^|\.)shopify\.com$/.test(imageUrl.hostname) && !/(^|\.)infraredi\.(com|com\.au|ca|co\.uk)$/.test(imageUrl.hostname)) throw new Error('Unsupported image URL');
      productImage = imageUrl.href;
    } catch (_) { productImage = ''; }
    var marketOrigin = String(context.origin || '');
    if (!/^https:\/\/(www\.)?infraredi\.(com|com\.au|ca|co\.uk)$/.test(marketOrigin)) throw new Error('This offer is not available for the selected storefront.');
    var setup = String(input.setup || '').trim().slice(0, 100);
    var productUrl = marketOrigin + '/products/' + handle;
    if (setup && /^infraredi-pro-/.test(handle)) productUrl += '?setup=' + encodeURIComponent(setup);
    return {
      email: email,
      properties: {
        ir_quiz_source: 'Device Quiz', ir_quiz_version: '2026-09',
        ir_quiz_goal: GOALS[answers.goal], ir_quiz_welcome_goal: GOALS[goal],
        ir_quiz_welcome_region: region,
        ir_quiz_welcome_route: region + ':' + goal, ir_quiz_answers: answers,
        ir_active_welcome_goal: GOALS[goal],
        ir_active_welcome_region: region,
        ir_active_welcome_route: region + ':' + goal,
        ir_quiz_recommended_product: handle,
        ir_quiz_recommended_product_name: productName,
        ir_quiz_recommended_product_url: productUrl,
        ir_quiz_recommended_product_image: productImage,
        ir_quiz_recommended_setup: setup,
        ir_quiz_email_opt_in: true, ir_quiz_consent_version: '2026-09-23',
        shopify_country_code: country, shopify_country: context.countryName || country,
        shopify_market_id: String(context.marketId || ''), shopify_market: context.marketHandle || '',
        shopify_currency: context.currency || '', shopify_locale: context.locale || '',
        ir_quiz_storefront: context.origin || '', ir_quiz_completed_at: new Date().toISOString()
      }
    };
  }
  async function submit(input, config, transport) {
    if (!config.enabled) throw new Error('Email signup is being connected. Please try again shortly.');
    if (!/^[a-zA-Z0-9]{6}$/.test(config.companyId || '') || !config.listId) throw new Error('Email signup is temporarily unavailable.');
    var profile = properties(input, config), send = transport || fetch;
    async function request(path, data) {
      var controller = new AbortController();
      var timer = setTimeout(function () { controller.abort(); }, 15000);
      try {
        var response = await send('https://a.klaviyo.com/client/' + path + '/?company_id=' + encodeURIComponent(config.companyId), {
          method: 'POST', headers: { 'Content-Type': 'application/vnd.api+json', revision: '2026-07-15' },
          body: JSON.stringify({ data: data }), signal: controller.signal
        });
        if (response.status !== 202) throw new Error('We couldn’t submit your request. Please try again.');
      } finally { clearTimeout(timer); }
    }
    // A repeat quiz must refresh the recommendation even when the email is
    // already subscribed and therefore cannot rejoin the welcome list.
    await request('profiles', {
      type: 'profile', attributes: { email: profile.email, properties: profile.properties }
    });
    await request('subscriptions', {
      type: 'subscription',
      attributes: { custom_source: 'Infraredi Device Quiz', profile: { data: { type: 'profile', attributes: {
        email: profile.email, properties: profile.properties,
        subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } }
      } } } },
      relationships: { list: { data: { type: 'list', id: config.listId } } }
    });
    // Results are already on the profile in the subscription request. Event tracking
    // is supplementary: its failure must never ask someone to subscribe twice.
    var eventAccepted = true;
    try {
      await request('events', { type: 'event', attributes: {
        unique_id: input.submissionId, properties: profile.properties,
        metric: { data: { type: 'metric', attributes: { name: 'Infraredi Device Quiz Completed' } } },
        profile: { data: { type: 'profile', attributes: { email: profile.email } } }
      } });
    } catch (error) { eventAccepted = false; }
    return { accepted: true, eventAccepted: eventAccepted };
  }
  return { properties: properties, submit: submit };
});
